import React, { useState } from 'react';
import ContactModal from './ContactModal';
import './CTASection.css';

const CTASection = ({ 
  title = "Ready to Start Your Project?", 
  description = "Contact us today for a free consultation and quote.",
  buttonText = "Get Free Quote",
  onClick = null,
  showModal = true,
  className = ""
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = () => {
    if (onClick) {
      // Use custom onClick handler if provided
      onClick();
    } else if (showModal) {
      // Default behavior: open modal
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <div className={`cta-section ${className}`}>
        <h2>{title}</h2>
        <p>{description}</p>
        <button 
          className="cta-button" 
          onClick={handleButtonClick}
          tabIndex={0}
        >
          {buttonText}
        </button>
      </div>
      
      {showModal && (
        <ContactModal 
          isOpen={isModalOpen} 
          onClose={() => setIsModalOpen(false)} 
        />
      )}
    </>
  );
};

export default CTASection;
